<!--
 * @Descripttion: 
 * @version: 
 * @Author: 杨海波
 * @Date: 2021-05-11 17:26:30
 * @LastEditors: 杨海波
 * @LastEditTime: 2021-07-15 10:48:11
 * @FilePath: /intell-loan/src/views/pages/publicPage/login/index.vue
-->
<template>
  <div class="Login">
    <login-tab></login-tab>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import LoginTab from './components/LoginTab.vue';


export default {
  name: 'Login',
  data() {
    return {}
  },
  components: {
    LoginTab,
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),

  },
};
</script>
<style scoped>
.Login{
  width: 100%;
  height: 100%;
}
.Login >>>.agreement{
  float: left;
}
.Login >>> input::-webkit-input-placeholder {
  color: #B8C4CC;
}
.Login >>> input::-moz-input-placeholder {
  color: #B8C4CC;
}
.Login >>> input::-ms-input-placeholder {
  color: #B8C4CC;
}
</style>
